import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Checkup from "../components/checkup"
import checkModal from "../assets/img/check-modal.png"
import produksiyon from "../assets/img/produksiyon-hizmeti.webp"
import answers from "../assets/img/answers-sol.webp"
import work from "../assets/img/aeo-hizmetleri.webp"
import imageUrl from "../assets/img/aeo-ico.webp"

class Geo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
      value: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  showModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.add("active-modal")
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.remove("active-modal")
  }

  handleSubmit(e) {
    e.preventDefault()
    const title = document.title.split("|", 1).toString()
    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7", {
      method: "POST",
      body: JSON.stringify({
        text_327649: title,
        text_204202: document.querySelector("#site").value,
        text_775908: document.querySelector("#name").value,
        text_532192: document.querySelector("#email").value,
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    response.then(res => {
      if (res.status === 200) {
        document.querySelector(".status").innerHTML = "Your message has been sent successfully."
      } else {
        document.querySelector(".status").innerHTML = "An error occurred."
      }
    })
  }

  render() {
    return (
      <Layout>
        <SEO
          title="GEO - Generative Engine Optimization | Flatart"
          description="GEO (Generative Engine Optimization) ensures your content is visible in AI-powered search engines like ChatGPT, Gemini, and Perplexity. Get started with Flatart."
        />

        {/* HERO */}
        <div className="seo-service container">
          <div className="seo-service__head custom">
            <div className="col-md-6">
              <h1>GEO (Generative Engine Optimization)</h1>
              <span className="red-head">AI STUDIO</span>
              <p className="red-pp">
                GEO is the approach of optimizing your website not just for ranking, but to be cited and become the source of answers by generative AI engines like ChatGPT, Gemini, and Perplexity.
              </p>
              <p className="red-pp">
                In this era where AI is fundamentally changing search habits, we build your GEO strategy together — ensuring your brand gets recommended more on AI platforms and positioned as a trusted source.
              </p>
              <div className="ai-input-wrap">
                <input
                  type="text"
                  className="pink-input"
                  placeholder="Enter your e-mail address"
                  value={this.state.value}
                  onChange={this.handleChange}
                />
                <button className="red-button" onClick={() => this.showModal()}>
                  Get in Touch
                </button>
              </div>
            </div>
            <div className="col-md-6 seo-top-right">
              <img alt="GEO - Generative Engine Optimization" src={produksiyon} />
            </div>
            <div className="check-modal">
              <span onClick={() => this.closeModal()}>X</span>
              <h2 className="form-head">Fill the form</h2>
              <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
              <div className="check-modal_container">
                <form onSubmit={e => this.handleSubmit(e)}>
                  <input type="text" name="text_204202" id="site" required placeholder="Enter your website." />
                  <input type="text" id="name" required name="text_775908" placeholder="Enter your name" />
                  <input type="email" id="email" required name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter your email" />
                  <button>SEND</button>
                  <div className="status"></div>
                </form>
                <img alt="" src={checkModal} />
              </div>
            </div>
          </div>
        </div>

        {/* WHAT IS GEO */}
        <div className="seo-service gads container yapay">
          <div className="row labh2">
            <div className="ai-ort yapay" style={{ marginTop: 10 }}>
              <h2 className="h2-ai-h2">What is GEO?</h2>
              <p className="flatlab-p now s">
                GEO is the practice of structuring your content so that LLMs can understand and cite it. While traditional SEO brings you to search results, GEO makes your brand a direct part of the answers generated by AI.
              </p>
            </div>
          </div>

          {/* WHY GEO */}
          <h2 className="h2-ai-h2 answer">Why Do You Need GEO?</h2>
          <div className="row align-items-center my-5">
            <div className="col-md-6 text-center">
              <img className="img-fluid" alt="GEO - Generative Engine Optimization" src={answers} />
            </div>
            <div className="col-md-6">
              <ul className="list-unstyled mb-0">
                {[
                  "GEO optimizes your content not only for humans but also for generative AI engines like ChatGPT, Gemini, and Perplexity.",
                  "You become the \"cited source\" in AI answers and areas like Google AI Overviews.",
                  "Your brand credibility increases; AI starts recognizing you as a \"known and trusted source\".",
                  "You build a future-ready digital presence; findability and user engagement improve.",
                  "Your reach expands; you deliver real value to a wider audience.",
                ].map((item, i) => (
                  <li className="d-flex lh-lg mb-2" key={i}>
                    <span className="list-dot me-2" style={{ color: "#ea4f6a" }}>•</span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* JOURNEY CIRCLES */}
        <div className="seo-process py60 container">
          <h2>GEO Journey with Flatart</h2>
          <p className="flatlab-p now s mb-2">
            In this era where AI is changing search habits, we clearly identify where your brand appears on AI platforms and create a roadmap. Before starting, we analyze who gets recommended in your industry, where competitors are gaining ground, and prioritize the steps that will deliver the fastest results.
          </p>
          <div className="circles">
            <div className="circle">
              <h3>Current GEO Visibility Analysis</h3>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle">
              <h3>AI-Compatible Content Architecture</h3>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle">
              <h3>Continuous Monitoring &amp; Optimization</h3>
            </div>
          </div>
        </div>

        {/* SEO vs GEO */}
        <div className="aeo-seo-wrapper">
          <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>SEO vs. GEO</h2>
          <div className="aeo-seo-grid">
            <div className="aeo-seo-card-container">
              <div className="aeo-seo-card">
                <div className="aeo-seo-content">
                  <div className="aeo-seo-top">
                    <ul className="aeo-seo-list">
                      <li>Being the brand recommended by AI</li>
                      <li>Visibility on AI platforms</li>
                      <li>Positioning as a trusted source</li>
                    </ul>
                    <div className="aeo-seo-icon">
                      <img src={imageUrl} alt="GEO" />
                    </div>
                  </div>
                  <hr className="aeo-seo-hr" />
                  <p className="aeo-seo-title">GEO</p>
                </div>
              </div>
            </div>
            <div className="aeo-seo-card-container">
              <div className="aeo-seo-card">
                <div className="aeo-seo-content">
                  <div className="aeo-seo-top">
                    <ul className="aeo-seo-list">
                      <li>Click and organic traffic focused</li>
                      <li>Ranking at the top of search engines</li>
                      <li>Ranking via content + technical + authority signals</li>
                    </ul>
                    <div className="aeo-seo-icon">
                      <img src={imageUrl} alt="SEO" />
                    </div>
                  </div>
                  <hr className="aeo-seo-hr" />
                  <p className="aeo-seo-title">SEO</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* GEO SERVICES LIST */}
        <div className="onboarding container aeo">
          <div className="col-md-4">
            <img className="answers" alt="Generative Engine Optimization" src={work} />
            <h2 style={{ color: "#ea4f6a", fontWeight: "bold", marginTop: 20, fontSize: 17 }}>
              Generative Engine<br />Optimization (GEO) Services
            </h2>
            <p>
              In this era where AI recommends the right sources for the right questions, we plan and execute every step needed for your brand to be that source.
            </p>
          </div>
          <div className="col-md-8">
            <ul className="list-unstyled d-flex flex-wrap mb-0">
              <div className="col-md-6">
                {[
                  "LLM visibility audit and benchmarking",
                  "Competitor citation gap analysis",
                  "AI search performance monitoring",
                  "GEO-focused content strategy and production",
                  "Prompt and question intent research",
                ].map((item, i) => (
                  <li className="d-flex lh-lg mb-2" key={i}>
                    <span className="list-dot me-2" style={{ color: "#ea4f6a" }}>•</span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </div>
              <div className="col-md-6">
                {[
                  "GEO technical infrastructure setup",
                  "Schema markup and structured data",
                  "Brand authority and credibility work",
                  "AI crawler access optimization",
                  "Continuous monitoring, reporting, and optimization",
                ].map((item, i) => (
                  <li className="d-flex lh-lg mb-2" key={i}>
                    <span className="list-dot me-2" style={{ color: "#ea4f6a" }}>•</span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </div>
            </ul>
          </div>
        </div>

        <Checkup />

        {/* FAQ ACCORDION */}
        <div className="hiring" style={{ marginTop: 30, paddingBottom: 40 }}>
          <h2>Frequently Asked Questions</h2>
          <div className="hiring-tabs">
            {[...Array(6)].map((_, i) => (
              <input type="checkbox" name="dropdown" id={`geotab${i + 1}`} key={i} />
            ))}

            <div className="tab" id="tab1sec">
              <label htmlFor="geotab1"> </label>
              <h3><span>1</span> How is GEO different from SEO?</h3>
              <p>SEO aims to rank you at the top of search results; GEO ensures your name appears in answers generated by AI. The two complement each other — running together makes you visible on both search engines and AI.</p>
              <div className="plus"></div>
            </div>

            <div className="tab" id="tab2sec">
              <label htmlFor="geotab2"> </label>
              <h3><span>2</span> Is GEO only for big brands?</h3>
              <p>No. Any brand with genuine expertise in its industry can stand out in AI. With the right strategy, small and medium-sized brands can move much faster in this space than large competitors.</p>
              <div className="plus"></div>
            </div>

            <div className="tab" id="tab3sec">
              <label htmlFor="geotab3"> </label>
              <h3><span>3</span> Does GEO work affect my existing SEO strategy?</h3>
              <p>It has no negative effect — quite the contrary, it strengthens it. By making your existing content and technical infrastructure AI-friendly, you gain visibility from both channels.</p>
              <div className="plus"></div>
            </div>

            <div className="tab" id="tab4sec">
              <label htmlFor="geotab4"> </label>
              <h3><span>4</span> Which AI platforms do you work for?</h3>
              <p>We develop visibility strategies for all major generative AI platforms, primarily ChatGPT, Google Gemini, Perplexity, Microsoft Copilot, and Google AI Overviews.</p>
              <div className="plus"></div>
            </div>

            <div className="tab" id="tab5sec">
              <label htmlFor="geotab5"> </label>
              <h3><span>5</span> Does GEO require technical preparation on my site?</h3>
              <p>Yes. Fast-loading pages, organized heading structure, internal linking, and structured data setup form the technical foundation of GEO. We analyze your current state and address gaps together.</p>
              <div className="plus"></div>
            </div>

            <div className="tab" id="tab6sec">
              <label htmlFor="geotab6"> </label>
              <h3><span>6</span> How do you measure visibility in AI?</h3>
              <p>We monitor how often your brand is recommended on AI platforms, in which topics it appears, and how it compares to competitors — sharing it transparently with monthly reports.</p>
              <div className="plus"></div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Geo
